// ArtistHeader.tsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { m } from "framer-motion";
import { buildCloudinaryUrl } from "@/lib/cloudinaryUrl";
import { useIntakeCopy } from "../i18n/useIntakeCopy";
import { DUR, EASE_ENTER, SPRING_TOUCH } from "../motion/tokens";
import type { IntakeArtist } from "../types";

export function ArtistHeader({ artist }: { artist: IntakeArtist }) {
  const { c } = useIntakeCopy();
  const [coverLoaded, setCoverLoaded] = useState(false);
  return (
    <header className="relative overflow-hidden rounded-2xl border border-[var(--color-border)] bg-[var(--color-bg-card)]">
      {artist.coverImage && (
        <m.img
          src={buildCloudinaryUrl(artist.coverImage, { width: 1400, quality: 70 })}
          alt="" aria-hidden onLoad={() => setCoverLoaded(true)}
          className="absolute inset-0 h-full w-full object-cover"
          initial={{ opacity: 0, scale: 1.04 }}
          animate={coverLoaded ? { opacity: 0.45, scale: 1, transition: { duration: DUR.hero, ease: EASE_ENTER } } : {}}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--color-bg-card)] via-[var(--color-bg-card)]/60 to-transparent" />
      <div className="relative flex items-end gap-4 px-5 pb-5 pt-16 sm:px-8 sm:pt-24">
        <m.img
          src={artist.profilePicture ? buildCloudinaryUrl(artist.profilePicture, { width: 160 }) : "/static/images/decorations/chibis/image07.png"}
          alt="" className="h-16 w-16 rounded-full border-2 border-[var(--color-primary)] object-cover sm:h-20 sm:w-20"
          initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1, transition: { ...SPRING_TOUCH, delay: 0.15 } }}
        />
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-widest text-[var(--color-text-muted)]">{c.header.commissionWith}</p>
          <h1 className="truncate font-(family-name:--font-display) font-normal text-3xl text-[var(--color-text)] sm:text-4xl">{artist.name}</h1>
        </div>
        <Link to="/commission" className="ml-auto shrink-0 text-xs text-[var(--color-text-muted)] underline-offset-4 hover:text-[var(--color-primary)] hover:underline">
          {c.header.changeArtist}
        </Link>
      </div>
    </header>
  );
}
